  <template >
   <div class="formPosition" v-role="'ped'">
     <template>
  <v-container class="grey lighten-5">
<v-overlay :value="overlay">
                <v-progress-circular
                  indeterminate
                  size="64"
                ></v-progress-circular>
              </v-overlay>
    <v-row no-gutters>
      <v-col md="2">
        <v-btn style="margin-top:-10px;" to="relatorio-cadeira" fab small color="primary"><v-icon small>arrow_back</v-icon></v-btn>
      </v-col>
      <v-col md="6" >
          <h4 style="text-align:center;"> <span>Listagem dos dados</span></h4>
          <v-alert
              v-model="alert"
              dismissible
              :type="alertType"
              border="left"
            :icon="iconAlert"
            transition="scale-transition"
            :style="colorAlert"
              elevation="2"
            colored-border
            >
            {{msgAlert}}
          </v-alert>
      </v-col>
    </v-row>

     <v-card
    class="mx-auto"
  >
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="headline">Curso : {{ this.$store.state.objEstudante.curso}}</v-list-item-title>
        <v-list-item-title class="headline">Disciplina : {{ this.$store.state.objEstudante.disciplina}}</v-list-item-title>
        <v-list-item-subtitle>Anolectivo: {{ this.$store.state.objEstudante.anolectivo}}<span style="font-weight:bold;"> </span></v-list-item-subtitle>
      </v-list-item-content>
             <v-menu
      offset-y
      origin="center center"
      transition="scale-transition"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          fab dark color="teal"
          style="color:white"
          v-on="on"
        >
          <v-icon>print</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item   ><img   width="30px"  src="../../assets/excel.png"> <span style="margin-left:10px;">Impimir em Excel</span></v-list-item>
        <v-list-item  ><img   width="30px"  src="../../assets/pdf.png"><span style="margin-left:10px;"> Impimir em PDF</span></v-list-item>
      </v-list>
    </v-menu>
    </v-list-item>
<v-row>
  <v-col md="12">
    <v-card-text>
      <strong><v-chip color="primary" style="margin:4px;color:white">Dados</v-chip></strong>
    </v-card-text>
    <hr>
    <v-row>
      <v-col md="12">
        <v-data-table
            :headers="headers_"
            :items="this.movimentos"
            :hide-default-footer="true" :items-per-page="50000"
          >
          <template  v-slot:item.mfd="{ item }">
            <span :style="(item.mfd < 10)?'color:red':'color:green'">{{item.mfd}}</span>
         </template>
         <template  v-slot:item.cadeiraNota="{ item }">
            <span :style="(item.cadeiraNota < 10)?'color:red':'color:green'">{{item.cadeiraNota}}</span>
         </template>
      </v-data-table>
      </v-col>

    </v-row>
 <hr>
            <template  >
              <v-row>
                 <v-col md="4">
                    <span style="margin-left:54px;font-size:18px;font-weight:bold;">Nº de movimentações: <v-chip>{{this.movimentos.length}}</v-chip></span>
                 </v-col>
                 <v-col md="4">
                 </v-col>
              </v-row>

            </template>
  </v-col>
</v-row>
  </v-card>

  </v-container>

  </template>
   </div>
</template>

<script>
import axios from '../../plugins/axios'
import utilitarios, { IntegerToMoneyValue } from '../../plugins/utilitarios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')
export default {
  directives: { mask },
  data: () => ({
    html: '',
    price: 0,
    money: {
      decimal: ',',
      thousands: '.',
      suffix: ' Kz',
      precision: 2,
      masked: false
    },
    msgAlert: 'Factura anulada com sucesso',
    alert: false,
    colorAlert: 'green',
    overlay: false,
    movimentos: [],
    utilitarios: utilitarios,
    Pessoas_filtro: [],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 100 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    headers_: [
      { text: 'Estudante', value: 'nome' },
      { text: 'Média Anterior', value: 'mfd' },
      { text: 'Nota Exame', value: 'recurso' },
      { text: 'Nota Cadeira', value: 'cadeiraNota' },
      { text: 'Data de lançamento', value: 'data_2' },
      { text: 'Autor', value: 'autor' }
    ]

  }),

  computed: {

    idclasse () {
      return this.$store.state.idclasse
    },
    Integrado () {
      return ls.get('integrado') === '1'
    },
    totalGeral () {
      let valor = 0
      this.movimentos.forEach(element => {
        valor += parseInt(element.valorAPagar)
      })
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return valor
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.GerarRelatorio(this.$store.state.objEstudante)
  },
  methods: {

    async GerarRelatorio (params) {
      this.overlay = true
      try {
        this.movimentos = await axios
          .post('/relatorioCadeira', params)
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.overlay = false
        console.log('errrrrrrrrrrrrrrrrrrro' + error)
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      } finally {
      }
    }

  }

}

</script>
